import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaCarouselUtility from '@sparta.global.utilities/sparta-carousel-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { button } from '@sparta.global.helpers/button-helper/dist/es6.js';
import { carouselGroupHelper, carouselSlideHelper } from '@sparta.global.helpers/carousel-helper/dist/es6.js';
import { link } from '@sparta.global.helpers/sparta-helper/dist/es6.js';
import { assetUrl } from '@sparta.targeted-content.helpers/targeted-content-helper/dist/es6.js';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <h3 class=\"header\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"header") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <p class=\"subheader\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"subheader") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"slides") : depth0),{"name":"each","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":4},"end":{"line":29,"column":13}}})) != null ? stack1 : "");
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"carouselSlideHelper")||(depth0 && lookupProperty(depth0,"carouselSlideHelper"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"carouselSlideHelper","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":6},"end":{"line":28,"column":30}}})) != null ? stack1 : "");
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <div class=\"content--wrapper\" data-link=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"learnMore") : stack1)) != null ? lookupProperty(stack1,"URL") : stack1), depth0))
    + "\">\r\n        <div class=\"image-container\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"site"))) && lookupProperty(stack1,"isSkinny")),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.program(10, data, 0),"data":data,"loc":{"start":{"line":16,"column":10},"end":{"line":20,"column":17}}})) != null ? stack1 : "")
    + "        </div>\r\n        <div class=\"tile-text\">\r\n          <h4 class=\"title\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "</h4>\r\n          <p class=\"description\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"description") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n          <span class=\"learn-more\">"
    + container.escapeExpression((lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"learnMoreSmall") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":25,"column":35},"end":{"line":25,"column":66}}}))
    + "</span>\r\n        </div>\r\n      </div>\r\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <img class=\"tile-image\" src=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"image") : stack1), depth0))
    + "\" loading=\"lazy\" alt=\"\" />\r\n";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <img class=\"tile-image\" src=\""
    + container.escapeExpression((lookupProperty(helpers,"assetUrl")||(depth0 && lookupProperty(depth0,"assetUrl"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"image") : stack1),{"name":"assetUrl","hash":{},"data":data,"loc":{"start":{"line":19,"column":39},"end":{"line":19,"column":65}}}))
    + "\" loading=\"lazy\" alt=\"\" />\r\n";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"content--wrapper tile\" data-link=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"learnMore") : stack1)) != null ? lookupProperty(stack1,"URL") : stack1), depth0))
    + "\">\r\n      <div class=\"image-container\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"site"))) && lookupProperty(stack1,"isSkinny")),{"name":"if","hash":{},"fn":container.program(13, data, 0),"inverse":container.program(15, data, 0),"data":data,"loc":{"start":{"line":38,"column":8},"end":{"line":42,"column":15}}})) != null ? stack1 : "")
    + "      </div>\r\n      <div class=\"tile-text\">\r\n        <h4 class=\"title\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "</h4>\r\n        <p class=\"description\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"description") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n        <span class=\"learn-more show-for-medium-only\">"
    + container.escapeExpression((lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"learnMoreSmall") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":47,"column":54},"end":{"line":47,"column":85}}}))
    + "</span>\r\n        <span class=\"learn-more show-for-large-up\">"
    + container.escapeExpression((lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"learnMore") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":48,"column":51},"end":{"line":48,"column":77}}}))
    + "</span>\r\n      </div>\r\n    </div>\r\n";
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <img class=\"tile-image\" src=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"image") : stack1), depth0))
    + "\" loading=\"lazy\" alt=\"\" />\r\n";
},"15":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <img class=\"tile-image\" src=\""
    + container.escapeExpression((lookupProperty(helpers,"assetUrl")||(depth0 && lookupProperty(depth0,"assetUrl"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"image") : stack1),{"name":"assetUrl","hash":{},"data":data,"loc":{"start":{"line":41,"column":37},"end":{"line":41,"column":63}}}))
    + "\" loading=\"lazy\" alt=\"\" />\r\n";
},"17":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\"row link-container\">\r\n      <span>"
    + container.escapeExpression((lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"compareLink") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":57,"column":12},"end":{"line":57,"column":43}}}))
    + "</span>\r\n  </div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row header-row\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"header") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":4,"column":11}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"subheader") : stack1),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":4},"end":{"line":7,"column":11}}})) != null ? stack1 : "")
    + "</div>\r\n\r\n<div class=\"small-view hide-for-medium-up\">\r\n"
    + ((stack1 = (lookupProperty(helpers,"carouselGroupHelper")||(depth0 && lookupProperty(depth0,"carouselGroupHelper"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"carouselTiles") : stack1),{"name":"carouselGroupHelper","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":2},"end":{"line":30,"column":26}}})) != null ? stack1 : "")
    + "</div>\r\n\r\n<div class=\"row medium-up-view show-for-medium-up\">\r\n  <div class=\"large-12 tiles\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"carouselTiles") : stack1)) != null ? lookupProperty(stack1,"slides") : stack1),{"name":"each","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":35,"column":4},"end":{"line":51,"column":13}}})) != null ? stack1 : "")
    + "  </div>\r\n</div>\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"compareLink") : stack1),{"name":"if","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":55,"column":0},"end":{"line":59,"column":7}}})) != null ? stack1 : "")
    + "\r\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.merrill-homepage.modules/carousel-module",
  "version": "2.0.4",
  "id": "CarouselModule",
  "containerID": "merrillHomepageCarouselModule",
  "moduleName": "merrill-homepage-carousel-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "carousel-module",
  "data": {
    "init": "CarouselModule",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        button,
        carouselGroupHelper,
        carouselSlideHelper,
        link,
        assetUrl
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    button,
    carouselGroupHelper,
    carouselSlideHelper,
    link,
    assetUrl
  },
  "dependencies": {
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.5",
    "@sparta.global.vendors/handlebars": "^4.7.7",
    "@sparta.global.helpers/button-helper": "^1.0.0",
    "@sparta.global.helpers/sparta-helper": "^1.0.0",
    "@sparta.targeted-content.helpers/targeted-content-helper": "^1.0.0",
    "@sparta.global.helpers/carousel-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-carousel-utility": "^1.0.0"
  },
  "stores": []
};

/**
 * The CarouselModule Sparta Module.
 * carousel using siema carousel
 * @export
 * @class carouselModule
 * @extends Module
 */
class CarouselModule extends Module {
  /**
   * Creates an instance of CarouselModule.
   * @memberof CarouselModule
   * @param {Object} options Module options
   * @param {Object} context Module context
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * Done to avoid csp issues
   * @param {String} learnMoreLink
   * @returns {String} link to redirect
   */
  redirectClick(destination, key = 'location') {
    document[key] = destination;
  }

  /**
   * Called when this module is bootstrapped by the client.
   * @param {object} options The options this module was initialized with.
   * @returns {void}
   */
  init() {
    // Code to make the tiles fully clickable
    let tiles = document.querySelectorAll('.content--wrapper');
    tiles.forEach(element => {
      element.addEventListener('click', thingClicked => {
        // if its NOT the footnote
        if (!thingClicked.target.matches('span.spa-footnote-order')) {
          // find parent to find the link to redirect
          let parent = thingClicked.target.parentNode;
          // if you don't get the wrapper go one up
          if (!parent.matches('.content--wrapper')) {
            parent = parent.parentNode;
          }
          // get the link attribute
          let learnMoreLink = parent.getAttribute('data-link');
          // redirect to the page
          this.redirectClick(learnMoreLink);
        }
      });
    });
    spartaCarouselUtility.init();
  }
}
registerModuleClass({
  moduleClass: CarouselModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { CarouselModule as default, moduleConfig };
